import React, { useEffect, useRef, useState } from "react";
import { options } from "../services/rapidstor";
import Location from "../features/rapidstor/entities/Location";

interface Props {
  location: Location;
}

function RapidStor({ location }: Props) {
  const rapidStorRef = useRef<HTMLDivElement>(null);

  const [showNoUnits, setShowNoUnits] = useState<boolean>(false);

  useEffect(() => {
    if (!window.KeepSafe) {
      window.KeepSafe = {};
    }

    if (!window.rapidstor_api_tracking_listener) {
      window.rapidstor_api_tracking_listener = function (type) {
        if (type === "unit-listing-loaded") {
          setShowNoUnits(document.querySelectorAll(".no-results-wrap").length > 0);
        }
      };
    }
  }, [showNoUnits]);

  useEffect(() => {
    if (window.KeepSafe.rapidStorLoadingLocal) {
      return;
    }

    if (!rapidStorRef.current) {
      return;
    }

    if (!location.token) {
      return;
    }

    const child = document.createElement("div");
    child.setAttribute("id", "rapidstor-app");
    rapidStorRef.current.replaceChildren();
    rapidStorRef.current.appendChild(child);

    window.KeepSafe.rapidStorLoadingLocal = true;

    const o = {
      mode: "unit-listing",
      token: {
        corp: "feee2c606163084113dbecafb9e6b8025974406f8420766484bfa166af67484ee662ac39cf9aab5b2416555afac4837f",
        site: location.token,
      },
      url: options.baseURL.replace(/\/$/, ""),
      parent_element_id: "rapidstor-app",
      mount_element: "#rapidstor-app",
      script_path: "/public/application/scripts/publicPanel/bootstrapper/bootstrapper.js",
      ignore_template: false,
      standalone: false,
      load_scripts: !window.KeepSafe.rapidStorLoaded,
    };

    window.KeepSafe.rapidStorLoaded = true;

    const t = rapidStorRef.current;
    const s = document.createElement("script");
    const e = Math.round(new Date().getTime() / 1000);
    window.rapidstor_options = o;
    s.src = o.url + o.script_path + "?epoch=" + e;
    console.log("rsbsl: loading '" + s.src + "'...");
    s.type = "text/javascript";
    s.async = true;
    s.onload = function () {
      console.log("rsbsl: loaded '" + s.src + "'.");
      window.KeepSafe.rapidStorLoadingLocal = false;
    };
    t.appendChild(s);
  }, [location.token]);

  return <div ref={rapidStorRef}></div>;
}

export default RapidStor;
